import React, { Fragment } from "react";
import Image from "next/image";
import arrow from "../../assets/images/arrow.png";
import styles from "@/styles/perfect_gift.module.scss";
import { homeLinks } from "@/data/home";
import Link from "next/link";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination, Navigation } from "swiper";

const Perfect_Gift = () => {
  return (
    <Fragment>
      <section className={styles.perfect_gift}>
        <div className="w-100">
          <div className={styles.perfect_gift_header}>
            <h2>{homeLinks.perfectGift.title}</h2>
          </div>
          <Swiper
            className="swiper-navigation-black swiper-custom-arrows pb-4"
            spaceBetween={0}
            slidesPerView={5}
            navigation={true}
            modules={[Navigation]}
            centeredSlides={false}
            breakpoints={{
              1199: {
                slidesPerView: 5,
              },
            }}
          >
            {homeLinks.perfectGift.images.map((v: any, i) => (
              <SwiperSlide key={i}>
                <Link href={v.link} passHref>
                  <div className="w-100">
                    <div className={styles.gift_jwellery}>
                      <Image
                        src={v.image}
                        className="img-fluid"
                        alt={v.name}
                        width={204}
                        height={312}
                      />

                      <div className={styles.gift_text}>
                        <div className={styles.h3_sub}>{v.name}</div>
                      </div>
                    </div>
                  </div>
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>

          <div className="text-center pt-0">
            <a
              href={homeLinks.perfectGift.link}
              className={styles.btn_get_started}
            >
              Explore All Gifts <i className="bi bi-arrow-right"></i>
              {/* <Image src={arrow} className="img-fluid" alt="" /> */}
            </a>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default Perfect_Gift;
